import { InputField } from './InputField';

export function TextField(props) {
  return <InputField {...props} />;
}
